export const IGNORED = "IGNORED";

export type Test = () => Promise<void | "IGNORED">;

export interface TestCase {
  test: Test;
  name: string;
}

export enum TestState {
  success = "SUCCESS",
  failed = "FAILED",
  ignored = "IGNORED",
}

export interface TestResult extends TestCase {
  state: TestState;
  error?: string;
  errorObject?: any;
  _diffReadable?: () => JSX.Element;
  time: number;
}

export async function subTestContext<T>(subContextMessage: string, subtest: () => T): Promise<T> {
  try {
    return await subtest();
  } catch (e) {
    const ex = e as any;
    if (ex.message) {
      ex.message = subContextMessage + " " + ex.message;
    }
    throw ex;
  }
}
